import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@components/Carousel/RelatedStoriesCarousel.css";

import ArticleCard from "@components/Cards/ArticleCard";
import Heading from "@elements/Typography/Heading";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import cx from "classnames";
import ReactSlick, { Settings } from "react-slick";
import { twMerge } from "tailwind-merge";

export type RelatedStoriesCarouselProps = {
  testId?: string;
  rootClassName?: string;
  relatedArticles: ProcessedArticleData[];
  source?: string;
};

type ReactSlickModule = typeof ReactSlick & {
  default?: typeof ReactSlick;
};
const Slider = (ReactSlick as ReactSlickModule).default ?? ReactSlick;

export default function RelatedStoriesCarousel({
  testId,
  rootClassName,
  relatedArticles,
  source,
}: RelatedStoriesCarouselProps): React.ReactElement {
  const settings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 3.8,
    className: cx("lg:grid-cols-1 lg:gap-6 lg:block lg:-mr-5"),
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.5,
          swipeToSlide: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div
      className={twMerge("related-stories", rootClassName)}
      data-testid={testId}
    >
      <Heading
        Element="h6"
        className="font-primary font-bold text-3xl mb-3 text-black leading-10.5"
      >
        RELATED STORIES
      </Heading>
      <Slider {...settings}>
        {relatedArticles.map((item) => {
          return (
            <ArticleCard
              key={item.id}
              displayWidth={210}
              displayHeight={157}
              overrideStyle={{
                cardWrapper:
                  "flex flex-col items-center justify-center w-full pr-xs py-0 border-0",
                contentWrapper: "w-full",
                imageWrapperStyle: "w-[210px]",
                titleClass: "text-grey-200 text-base font-opensans leading-6",
              }}
              refMedium={source}
              {...item}
              elements={{
                hasParagraph: false,
                hasDate: true,
              }}
            />
          );
        })}
      </Slider>
    </div>
  );
}
